import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { AsyncEntity } from 'src/global';
import { RootState } from 'src/store';
import { templatesSelectors } from 'src/features/templates/templates.state';
import { ContentTemplate, ContentTemplateCompany, ContentTemplateGroup } from 'src/features/templates/templates.types';
import { Collection } from 'src/features/collections/collections.types';
import { offlineTemplateSelectors } from 'src/features/templates/offlineTemplate.state';

export const useCompanyOfflineTemplate = (companyId: string): AsyncEntity<ContentTemplate> | null => {
  const state = useSelector<RootState, RootState['offlineTemplate']>(state => state.offlineTemplate);

  const result = offlineTemplateSelectors.selectById(state, companyId) || null;

  useDebugValue(result);

  return result;
};

export const useTemplatesState = (): RootState['templates'] => {
  const state = useSelector<RootState, RootState['templates']>(state => state.templates);

  useDebugValue(state);

  return state;
};

export const useTemplates = (): ContentTemplate[] => {
  const state = useSelector<RootState, RootState['templates']>(state => state.templates);

  const result = templatesSelectors.selectAll(state);

  useDebugValue(result);

  return result;
};

export const useTemplateById = (id: string): AsyncEntity<ContentTemplate> | null => {
  const state = useSelector<RootState, RootState['templates']>(state => state.templates);

  const result = templatesSelectors.selectById(state, id) || null;

  useDebugValue(result);

  return result;
};

export const useTemplateCollectionsSectionById = (id: string): AsyncEntity<Collection[]> => {
  const state = useSelector<RootState, RootState['templates']>(state => state.templates);

  const result = templatesSelectors.selectById(state, id) as ContentTemplate;

  useDebugValue(result);

  return result.videos?.collections || [];
};

export const useTemplateCompaniesSectionById = (id: string): AsyncEntity<ContentTemplateCompany[]> => {
  const state = useSelector<RootState, RootState['templates']>(state => state.templates);

  const result = templatesSelectors.selectById(state, id) as ContentTemplate;

  useDebugValue(result);

  return result.companies || [];
};

export const useTemplateGroupsSectionById = (id: string): AsyncEntity<ContentTemplateGroup[]> => {
  const state = useSelector<RootState, RootState['templates']>(state => state.templates);

  const result = templatesSelectors.selectById(state, id) as ContentTemplate;

  useDebugValue(result);

  return result.groups || [];
};
